import { ac } from '../actions'

export const SCREEN_SIZE_UPDATE = 'SCREEN_SIZE_UPDATE'

export const updateScreenSize = (size: any, clientWidth: any) =>
  ac(SCREEN_SIZE_UPDATE, { size, clientWidth })
